import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2'

const config = require('../config.json')

export default function Login({ ipAddress, onLogin }) {
    const [lid, setlid] = useState('')
    const [pass, setpass] = useState('')
    const history = useHistory();
    const handleLogin = async (event) => {
        event.preventDefault()
        login();
    }
    
    const login = async () => {
        let ip = ipAddress
        let data = JSON.stringify({
            "lid": lid,
            "password": pass,
            "ip": ip
        });
        let axiosConfig = {
            method: 'post',
            url: `${config.baseUrl}index`,
            headers: {
                'ulid': lid,
                'ip': ip,
                'Content-Type': 'application/json'
            },
            data: data
        };
        let res = await axios.request(axiosConfig)
        let response = res.data
        console.log(response)
        if (response.status) {

            let loginData = response.data

            if ((response?.info?.sponsor_id).length > 3) {
                await setLoginData(loginData)
                onLogin(response.data)
                // handCheck(loginData)
                history.push('/dash');
            }
            else {
                Swal.fire({
                    icon: 'info',
                    title: 'AD Herbal',
                    text: "Please Login again."
                })
            }

        }
        else if (response.code === 30) {
            Swal.fire({
                icon: 'info',
                title: 'AD Herbal',
                text: response?.message
            }).then(() => {
                history.push('/register');
            })
        }
        else {
            Swal.fire({
                icon: 'info',
                title: 'AD Herbal',
                text: response?.message
            })
        }
    };
    const handCheck = async (data) => {
        let data2 = JSON.stringify({
            ip: ipAddress,
            ulid: data.ulid,
          });
          let axiosConfig = {
            method: "post",
            url: `${config.baseUrl}desk`,
            headers: {
              ip: ipAddress,
              ulid: data.ulid,
              auth: data.auth,
              token: data.token,
              "Content-Type": "application/json",
            },
            data: data2,
          };
          //console.log(axiosConfig)
          let response = await axios.request(axiosConfig);
          console.log(response.data);
          response = response.data;
          
          if (response.status) {
            history.push('/dash');
          } else {
            Swal.fire({
              icon: "info",
              title: "AD Herbal",
              text: "Please Login again",
            });
          }
    }
    async function setLoginData(loginData) {
        localStorage.setItem('loginData', JSON.stringify(loginData));
    }
    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y" >
                <div className="authentication-inner py-4">
                    {/* Forgot Password */}
                    <div className="card">
                        <div className="card-body">
                            {/* Logo */}
                            <div className="app-brand justify-content-center" style={{ marginBottom: '10px' }}>
                                <Link to="/" className="app-brand-link gap-2">
                                    <span className="app-brand-logo demo">
                                        <img src="logo.png" style={{ height: '150px', width: 'auto' }} alt='ficon' />
                                    </span>
                                </Link>
                            </div>
                            {/* /Logo */}
                            <form id="formAuthentication" className="mb-3" onSubmit={handleLogin}>
                                <div className="mb-3">
                                    <label htmlFor="1email" className="form-label">User ID</label>
                                    <input type="text" className="form-control" id="lid" name="lid" placeholder="Enter User ID" value={lid} onChange={(e) => setlid(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="e1mail" className="form-label">Password</label>
                                    <input type="password" className="form-control" id="pass" name="pass" placeholder="Enter your name" value={pass} onChange={(e) => setpass(e.target.value)} />
                                </div>
                                <button className="btn btn-secondary d-grid w-100 d-flex" ><i className="fas fa-forward me-2 text-black"></i>Login </button>
                            </form>
                        </div>
                    </div>
                    <div className="card mt-4">
                        <div className="card-body">
                            <Link to="/register" className="d-flex align-items-center justify-content-center text-black btn btn-success ">
                                <i className="fas fa-user me-2 text-danger" ></i>Not Register? Click to Register
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
